<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container">
    <ion-row class="content-padding-vertical" justify-content-center>
      <ion-col size="12">
        <app-modal-header
          header="{{ 'REPORT_TASK.ADD_TASK' | translate }}"
          (close)="close()"
        >
        </app-modal-header>
      </ion-col>
      <ion-col size="12" class="add-report-task__form-container">
        <app-select-user
          [label]="label"
          (changeValueEvent)="isMissing($event)"
        ></app-select-user>
        <ion-label color="danger" *ngIf="userMissing" class="font-size__16">
          {{ 'REQUIRED_VALIDATION' | translate }}
        </ion-label>
        <ion-item class="input">
          <div class="control-display">
            <ion-label>{{ 'REPORT_TASK.DESCRIPTION' | translate }}</ion-label>
            <ion-textarea
              rows="2"
              [(ngModel)]="reportTaskServ.reportTask.description"
              [autoGrow]="!reportTaskServ.reportTask.description"
              [ngModelOptions]="{standalone: true}"
            ></ion-textarea>
          </div>
        </ion-item>
        <ion-item class="input" lines="none">
          <ion-button
            class="button-margin-top-md"
            (click)="Save()"
            size="medium"
            slot="end"
            [disabled]="reportTaskSaving"
          >
            <ng-container *ngIf="!reportTaskSaving">
              {{'SAVE' | translate}}
            </ng-container>
            <ng-container *ngIf="reportTaskSaving">
              {{'SAVING' | translate}}
            </ng-container>
          </ion-button>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
